// module.exports = {
//   body: '#FFFFFF',
//   background: '#FFFFFF',
//   backgroundDark: '#f0e6f6',

//   text: '#333333',
//   navtext: '#7c37ad',

//   primary: '#7c37ad',
//   primaryLight: '#ae66df',
//   primaryDark: '#add8e6',

//   secondary: '#f0e6f6',
//   secondaryLight: '#ffccdd',
//   secondaryDark: '#c60055',
// };

module.exports = {
  body: '#060c12',
  background: '#191d2b',
  backgroundDark: '#10121b',

  text: '#fafafa',
  navtext: '#e0e0e0',

  primary: '#e0e0e0',
  primaryLight: '#191d2b',
  primaryDark: '#191d2b',

  secondary: '#10121b',
  secondaryLight: '#191d2b',
  secondaryDark: '#10121b',
};
